module.exports = __webpack_public_path__ + "img/14.4ffc0edb.jpg";